// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import { cid } from '@/config'
let configs = ''
let configs_obj = ''
if (cid == 'chile-infinix') {
    configs = require('@/assets/appConfigs/chile-infinix.json')
    configs_obj = 'chile-infinix'
} else if (cid == 'chile-tecno') {
    configs = require('@/assets/appConfigs/chile-tecno.json')
    configs_obj = 'chile-tecno'
} else if (cid == 'meizu') {
    configs = require('@/assets/appConfigs/meizu.json')
    configs_obj = 'meizu'
} else if (cid == 'bolivia-mi') {
    configs = require('@/assets/appConfigs/bolivia-mi.json')
    configs_obj = 'bolivia-mi'
} else if (cid == 'realme') {
    configs = require('@/assets/appConfigs/realme.json')
    configs_obj = 'realme'
} else if (cid == "starcell") {
    configs = require('@/assets/appConfigs/starcell.json')
    configs_obj = 'starcell'
}

// 配置项目名称 - index.html title
document.title = configs.projectName

Vue.prototype.$configs = configs
Vue.prototype.$configs_obj = configs_obj
Vue.prototype.$HomeUrl = configs.HomeUrl

// 配置项目名称 - index.html title
document.title = 'Warranty Check'

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js